/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightDownIcon16Light = forwardRef('ArrowDUturnRightDownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 7.5a5.5 5.5 0 1 0-11 0v4a.5.5 0 0 0 1 0v-4a4.5 4.5 0 0 1 9 0v5.185L7.874 9.168a.5.5 0 1 0-.748.664l3.253 3.66a1.5 1.5 0 0 0 2.242 0l3.253-3.66a.5.5 0 1 0-.748-.664L12 12.685V7.5Z" })));
});
